import { Route, Switch, Redirect } from 'wouter';
import { RequireAuth, RedirectIfAuthed } from './components/Guards';
import { LoginPage, RegisterPage } from './pages/auth';
import { LandingPage, PrivacyPage, TermsPage, DataDeletionPage, NotFoundPage } from './pages/static';
import { OverviewPage } from './pages/Overview';
import { LeadsPage, LeadDetailPage } from './pages/Leads';
import { ConnectionsPage } from './pages/Connections';
import { FormsPage } from './pages/Forms';
import { SettingsPage, SettingsProfilePage, WebhookHealthPage } from './pages/simple';

const auth = (C: React.ComponentType<any>) => (props: any) => (
  <RequireAuth>
    <C {...props} />
  </RequireAuth>
);

export function App() {
  return (
    <Switch>
      {/* public */}
      <Route
        path="/"
        component={() => (
          <RedirectIfAuthed>
            <LandingPage />
          </RedirectIfAuthed>
        )}
      />
      <Route
        path="/login"
        component={() => (
          <RedirectIfAuthed>
            <LoginPage />
          </RedirectIfAuthed>
        )}
      />
      <Route
        path="/register"
        component={() => (
          <RedirectIfAuthed>
            <RegisterPage />
          </RedirectIfAuthed>
        )}
      />
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="/terms" component={TermsPage} />
      <Route path="/data-deletion" component={DataDeletionPage} />

      {/* app */}
      <Route path="/overview" component={auth(OverviewPage)} />
      <Route path="/leads" component={auth(LeadsPage)} />
      <Route path="/leads/:id" component={auth(LeadDetailPage)} />
      <Route path="/connections" component={auth(ConnectionsPage)} />
      <Route path="/facebook" component={auth(ConnectionsPage)} />
      <Route path="/facebook-accounts" component={auth(ConnectionsPage)} />
      <Route path="/forms" component={auth(FormsPage)} />
      <Route path="/settings" component={auth(SettingsPage)} />
      <Route path="/settings/profile" component={auth(SettingsProfilePage)} />
      <Route path="/webhook" component={auth(WebhookHealthPage)} />
      <Route path="/activity">
        <Redirect to="/overview" />
      </Route>
      <Route path="/logs">
        <Redirect to="/overview" />
      </Route>

      <Route path="/404" component={NotFoundPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
}
